import styled from 'styled-components';
import { themeColors } from 'themes';
import breakpoints from 'constants/breakpoints';

export const NavItem = styled.div<{ hideOnMobile?: boolean }>`
  display: block;
  @media (max-width: ${breakpoints.size.lg}px) {
    display: ${(props) => (props.hideOnMobile === true ? 'none' : 'block')};
  }

  text-align: left;
  border: 0;
  width: 100%;
  a {
    display: block;
    line-height: inherit;
    cursor: pointer;
    text-align: center;
  }
  ul {
    list-style: none;
    z-index: 999;
    padding-left: 0;
    margin-top: 0;
    margin-bottom: 0;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    li {
      .nav-menu__tab {
        font-size: clamp(12px, 1.5vw, 14px);
      }
    }
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: start;
  font-size: 0.8125rem;
  .nav__menu-item {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 0rem 0.2rem 0rem 0rem;
    cursor: pointer;
    border-radius: 0;
  }
  .icon {
    padding-left: 1rem;
  }
`;

export const Tab = styled.a<{ $isSelected?: boolean; layer?: 'second' | 'third' }>`
  all: unset;
  color: ${(props) => (props.$isSelected ? themeColors.primaryBlue5 : themeColors.lightGrey8)};
  border: 0;
  font-size: 0.885rem;
  display: flex;
  font-weight: ${(props) => (props.$isSelected ? '600' : '400')};
  border-bottom: 2px solid ${(props) => (props.$isSelected ? themeColors.primaryBlue5 : 'none')};
  border: ${(props) => (props.layer === 'third' && props.$isSelected ? '1px solid #0076cc' : props.layer === 'third' ? "1px solid #A3A3A3" : "")};
  border-radius: ${(props) => (props.layer === 'third' ? '50px' : '')};
  padding-bottom: 0;
  background-color: ${(props) => (props.layer === 'third' && props.$isSelected ? '#EBF4FB' : '')};
  padding-right: ${(props) => (props.layer === 'third' ? '0px' : '0')};
  // padding: ${(props) => (props.layer === 'third' ? '0px 14px' : '')};
  padding: ${(props) => (props.layer === 'third' ? '8px 16px' : '18px 8px')};
`;
